import { Injectable } from "@angular/core";
import {
  Actions,
  createEffect,
  EffectNotification,
  ofType,
  OnRunEffects
} from "@ngrx/effects";
import {
  RoomMixerErrorEventVO,
  RoomMixerStartedEventVO,
  RoomMixerStartEventVO,
  RoomMixerToRotateEventVO
} from "@youm-front/room/domain";
import { Observable } from "rxjs";
import { exhaustMap, map, takeUntil } from "rxjs/operators";
import { RoomMixerActions } from "../actions";
import { RoomMixerEvents } from "../events";
import { RoomService } from "../services";

@Injectable()
export class RoomMixerEffects implements OnRunEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly roomService: RoomService
  ) {}

  listenRoomMixerError$ = createEffect(() =>
    this.roomService.listenRoomMixerError().pipe(
      map((_) =>
        RoomMixerEvents.roomMixerErrorEvent({
          roomMixerErrorEventVO: new RoomMixerErrorEventVO(_.data)
        })
      )
    )
  );

  listenRoomMixerStart$ = createEffect(() =>
    this.roomService.listenRoomMixerStart().pipe(
      map((_) =>
        RoomMixerEvents.roomMixerStartEvent({
          roomMixerStartEventVO: new RoomMixerStartEventVO(_.data)
        })
      )
    )
  );

  listenRoomMixerStarted$ = createEffect(() =>
    this.roomService.listenRoomMixerStarted().pipe(
      map((_) =>
        RoomMixerEvents.roomMixerStartedEvent({
          roomMixerStartedEventVO: new RoomMixerStartedEventVO(_.data)
        })
      )
    )
  );

  listenRoomMixerToRotate$ = createEffect(() =>
    this.roomService.listenRoomMixerToRotate().pipe(
      map((_) =>
        RoomMixerEvents.roomMixerToRotateEvent({
          roomMixerToRotateEventVO: new RoomMixerToRotateEventVO(_.data)
        })
      )
    )
  );

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>) {
    return this.actions$.pipe(
      ofType(RoomMixerActions.init),
      exhaustMap(() =>
        resolvedEffects$.pipe(
          takeUntil(this.actions$.pipe(ofType(RoomMixerActions.destroy)))
        )
      )
    );
  }
}
